<div class="container mt-lg-4 mt-0">
  <fgb-leaderboard [toShow]="20" [LeaderboardType]="LeaderboardType"></fgb-leaderboard>
</div>
